<div
  class="modal__background"
  (click)="onBackgroundClick()"
  role="button"
  data-testid="modal-background-testid"
  tabindex="0"
  [style.zIndex]="zIndex"
></div>
<div
  class="modal"
  [style.max-width.px]="maxWidth"
  [style.max-height.px]="maxHeight"
  [style.zIndex]="zIndex + 1"
>
  <ng-container *ngIf="!hideCloseButton">
    <div class="modal__header">
      <div
        class="modal__header__button"
        role="button"
        data-testid="modal-close-button-testid"
        tabindex="0"
        (click)="onCloseButtonClick()"
      >
        <pichincha-icon size="24px" custom-color-value="bp-grayScale400">close</pichincha-icon>
      </div>
    </div>
  </ng-container>
  <div class="modal__content">
    <ng-content></ng-content>
  </div>
  <div class="modal__buttons">
    <ng-container *ngIf="labelSecondaryButton">
      <pichincha-button
        custom-width="100%"
        size="large"
        variant="secondary"
        [disabled]="disableSecondaryButton"
        [label]="labelSecondaryButton"
        (click)="onSecondaryButtonClick()"
      ></pichincha-button>
    </ng-container>
    <pichincha-button
      custom-width="100%"
      size="large"
      [disabled]="disablePrimaryButton"
      [label]="labelPrimaryButton"
      (click)="onPrimaryButtonClick()"
    ></pichincha-button>
  </div>
</div>
